module.exports = __webpack_public_path__ + "img/icon_cowsitting_colour.4910e9cb.svg";